import { mediaRawUrl } from './media'

// Kept for compatibility: maps a stored image_path to an authenticated URL.
export function photoUrl(imagePath) {
  return mediaRawUrl(imagePath)
}
